<template>
    <div class="uk-section">
      <div class="uk-container uk-container-small">
        <h2>Nyheter</h2>
        <div class="uk-child-width-1-2" uk-grid>
          <div v-for="article in articles" v-bind:key="article.slug">
            <router-link
                :to="{ path: '/article/' + article.slug }"
                :key="article.slug"
              >
              <div class="uk-background-cover uk-height-medium uk-panel uk-flex uk-flex-center uk-flex-middle"
              v-bind:style="{ backgroundImage: 'url(' + api_url + article.image.url + ')' }">
              </div>
                  <h3>{{ article.title }}</h3>
              </router-link>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  data() {
    return {
      api_url: process.env.VUE_APP_STRAPI_API_URL,
      articles: []
    };
  },

  apollo: {
    articles: { 
      query: gql`
        query Articles {
          articles(sort: "published_at:desc") {
              id
              slug
              title
              image {
                url
              }
              author {
                id
                firstname
                lastname
                username
              }
              excerpt
              article
              published_at
              last_edited_date
          }
        }
    `,
    pollInterval: 3000 // ask for updated info every 10 seconds
  }
  }
};
</script>